import React from 'react';

import ConnectionPageLayout from '../../components/ConnectionPageLayout';
import ConnectionGuideContent from './ConnectionGuideContent';

const ConnectionGuidePageDesktop = ({deviceType, content, onNextStep}) => {
    const {
        actionButton,
        closeButton,
        title,
        images,
        videos,
        desktopBgColorHex,
        description,
        items,
        headerTitle,
        headerButton,
    } = content;

    return (
        <ConnectionPageLayout className='items-center ml:px-16'>
            <ConnectionPageLayout.Header title={headerTitle} button={headerButton} />
            <div className='my-12 flex w-full max-w-[1016px] flex-1 items-center gap-8 lg:max-w-[1336px] xl:gap-16'>
                <div className='flex flex-1 flex-col items-start' role='region' aria-live='polite'>
                    <ConnectionGuideContent.Title title={title} deviceType={deviceType} />
                    <ConnectionGuideContent.Description description={description} deviceType={deviceType} />
                    <ConnectionGuideContent.Instruction items={items} deviceType={deviceType} />
                    <ConnectionGuideContent.Buttons
                        className='mt-8'
                        btnClassName='w-full max-w-[312px]'
                        actionButton={actionButton}
                        closeButton={closeButton}
                        onNextStep={onNextStep}
                    />
                </div>
                <ConnectionGuideContent.Media
                    className='aspect-square w-[calc((100%-32px)*0.6)] shrink-0 md:rounded-3xl xl:w-[calc((100%-64px)*0.6)]'
                    bgColorHex={desktopBgColorHex}
                    images={images}
                    videos={videos}
                />
            </div>
        </ConnectionPageLayout>
    );
};

export default ConnectionGuidePageDesktop;
